export const HOME_URL = '/';
export const ABOUT_US_URL = '/about-us';
export const WELCOME_ANIM_URL = '/welcome-animation';

export const DANCE_SHOW_URL = '/dance-show';
export const GALLERY_URL = '/gallery';
export const CONTACT_US_URL = '/contact-us';

export const ENG_URL = '/en';
